import { createSlice } from '@reduxjs/toolkit';
import { deleteAgent, getAgent, getAgents } from './id8SettingsActions';

const initialState = {
  agentsList: [],
  isAgentsLoading: false,

  tableSettings: {
    search: '',
    sort: '-name',
    page: 0,
    size: 10,
    totalElements: 0,
  },

  editableAgent: {},
  isAgentLoading: false,

  loadingActions: {},
};

const id8Settings = createSlice({
  name: 'id8Settings',
  initialState,
  reducers: {
    changeTableSettings: (state, action) => {
      state.tableSettings = { ...state.tableSettings, ...action.payload };
    },

    resetId8SettingsData: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      //GET_AGENTS
      .addCase(getAgents.pending, (state) => {
        state.isAgentsLoading = true;
      })
      .addCase(getAgents.fulfilled, (state, action) => {
        const { page, size } = state.tableSettings;

        state.agentsList = action.payload.content?.map((agent, index) => ({
          count: index + 1 + size * page,
          ...agent,
        }));
        state.tableSettings.totalElements = action.payload.total;
        state.isAgentsLoading = false;
      })
      .addCase(getAgents.rejected, (state) => {
        state.isAgentsLoading = false;
      })

      //GET_AGENT
      .addCase(getAgent.pending, (state) => {
        state.isAgentLoading = true;
      })
      .addCase(getAgent.fulfilled, (state, action) => {
        state.editableAgent = action.payload;
        state.isAgentLoading = false;
      })
      .addCase(getAgent.rejected, (state) => {
        state.isAgentLoading = false;
      })

      //DELETE_AGENT
      .addCase(deleteAgent.pending, (state) => {
        state.isAgentsLoading = true;
      })
      .addCase(deleteAgent.rejected, (state) => {
        state.isAgentsLoading = false;
      });
  },
});

export const { changeTableSettings, resetId8SettingsData } = id8Settings.actions;

export default id8Settings.reducer;
